__webpack_require__.p = "/WEATHER_APP_GLOBE/";